import { useDebounce } from '@repo/toolkit/use-debounce'
import { ChangeEventHandler } from 'react'

import Input, { type InputProps } from './input'

type DebouncedInputProps = InputProps & {
  onChange: ChangeEventHandler<HTMLInputElement>
}

export function DebouncedInput({ onChange, ...props }: DebouncedInputProps) {
  const { debouncedCallback } = useDebounce(onChange, 1000)
  return <Input {...props} onChange={(e) => debouncedCallback(e)} />
}
